import { createAction, createReducer } from '@reduxjs/toolkit';
import {
  IAction,
  IDocumentosCliente,
  ITipoDocumento,
} from './interface/apiDocumentos';
import {
  IClientDocuments,
  IDocuments,
  IInitialState,
} from './interface/reduxApi';

const INITIAL_STATE: IInitialState = {
  documentsGotSuccess: false,
  customerDocumentsGotSuccess: false,
  isCustomerDocumentsLoading: false,
  isDocumentsLoading: false,
  gotError: false,
  clientDocuments: [],
  documents: [],
};

export const getCustomersDocumentsFromApi = createAction(
  '@clientsApp/customersDocuments/GET_DOCUMENTS_FROM_API'
);

export const gotCustomersDocumentsFromApi = createAction<any>(
  '@clientsApp/customersDocuments/GOT_DOCUMENTS_FROM_API'
);

export const gotError = createAction(
  '@clientsApp/customersDocuments/GOT_ERROR'
);

export const getDocumentsListFromApi = createAction(
  '@clientsApp/customersDocuments/GET_DOCUMENTS_LIST_FROM_API'
);

export const gotDocumentsListFromApi = createAction<any>(
  '@clientsApp/customersDocuments/GOT_DOCUMENTS_LIST_FROM_API'
);

function checkArray(array: any) {
  if (array === undefined) {
    return [];
  }
  return array;
}

const customersDocumentsReducer = createReducer(INITIAL_STATE, {
  [getCustomersDocumentsFromApi.type]: (state) => ({
    ...state,
    isCustomerDocumentsLoading: true,
    customerDocumentsGotSuccess: false,
    gotError: false,
  }),
  [getDocumentsListFromApi.type]: (state) => ({
    ...state,
    isDocumentsLoading: true,
    documentsGotSuccess: false,
    gotError: false,
  }),
  [gotCustomersDocumentsFromApi.type]: (state, action: IAction) => ({
    ...state,
    isCustomerDocumentsLoading: false,
    customerDocumentsGotSuccess: true,
    gotError: false,
    clientDocuments: checkArray(action.payload.documentos_clientes).map(
      (documentos: IDocumentosCliente) => {
        const documents: IClientDocuments = {
          clientAccountAndDigit: documentos.contaDigito_cliente,
          clientAgency: documentos.agencia_cliente,
          cnpfCnpj: documentos.cpfCnpj_cliente,
          createdAt: documentos.created_at,
          documentDescription: documentos.descricao_documento,
          documentLink: documentos.documento,
          documentType: documentos.tipo_documento,
          id: documentos.id,
          updatedAt: documentos.updated_at,
        };
        return documents;
      }
    ),
  }),
  [gotDocumentsListFromApi.type]: (state, action: IAction) => ({
    ...state,
    isDocumentsLoading: false,
    documentsGotSuccess: true,
    gotError: false,
    documents: checkArray(action.payload.tipo_documento).map(
      (documentos: ITipoDocumento) => {
        const documents: IDocuments = {
          documentDescription: documentos.descricao_documento,
          accountFormat: documentos.formato_conta,
          createdAt: documentos.created_at,
          id: documentos.id,
          updatedAt: documentos.updated_at,
        };
        return documents;
      }
    ),
  }),
  [gotError.type]: (state) => ({
    ...state,
    isCustomerDocumentsLoading: false,
    customerDocumentsGotSuccess: false,
    documentsGotSuccess: false,
    isDocumentsLoading: false,
    gotError: true,
  }),
});

export default customersDocumentsReducer;
